<div class="activity-stream-container">
  @if (showFilters) {
    <coin-c-activity-stream-tags></coin-c-activity-stream-tags>
  }
  <coin-c-activity-stream-header></coin-c-activity-stream-header>
  <coin-c-activity-stream-list></coin-c-activity-stream-list>
</div>
